import { Col } from 'components/Col';
import { CustomTextArea } from 'components/CustomTextArea';
import { Row } from 'components/Row';
import { ProjetosContext } from 'contexts/projetos/ProjetosContext';
import { EtapaProjeto } from 'models/projeto';
import { ChangeEvent, useContext, useMemo } from 'react';
import languageValues from 'utils/LanguageUtils';

const language = languageValues.inputs.descricaoComunidadeAprendizagem;
export default function ContribuicaoComunidade() {
  const { state, dispatch, validator } = useContext(ProjetosContext);

  const validation = useMemo(
    () =>
      validator?.getCampoIsValid({
        key: 'descricaoComunidadeAprendizagem',
        etapa: EtapaProjeto.aprendizagem,
        helperText: language?.required,
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [validator, state.sent]
  );

  return (
    <Row>
      <Col>
        <CustomTextArea
          label={language.label(state.projeto.flgInfantil)}
          placeholder={language.placeholder}
          name='descricaoComunidadeAprendizagem'
          value={state.projeto.descricaoComunidadeAprendizagem || ''}
          onChange={(event: ChangeEvent<HTMLInputElement>) => {
            dispatch({
              type: 'setProjeto',
              payload: {
                descricaoComunidadeAprendizagem: event.target.value,
              },
            });
          }}
          counter={true}
          maxSize={8000}
          error={state.sent && validation?.error}
          helperText={
            state.sent && validation?.error ? validation?.helperText : undefined
          }
          minRows={1}
          disabled={state.disabledFields}
        />
      </Col>
    </Row>
  );
}
